/**=========================================================
 * Module: projects.js
 * Projects Controller
 =========================================================*/

App.controller('ProjectsController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$filter', 'ngDialog',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $filter, ngDialog) {
    "use strict";

    $scope.type = 'project';
    $scope.filter = $state.params.filter;

    $scope.data = [];

    $scope.page = {
            title: 'labels.PROJECTS',
            subTitle: ''
        };

    $scope.openFileManager = function(project){
    	$state.go('app.entity',{action:'files',type:'project',filter:project.id});
    };

    $scope.initialized = false;
    $scope.watchActivated = false;
    $scope.init = function(){

        if($rootScope.user.id){
            $scope.initialized = true;

            $scope.table = {
                title: '',
                filter: true,
                orderBy: 'code',
				order: 'desc',
				includedFields: ['id'],
				cls: 'no-panel-table',
				containerStyle: {'min-height': '300px'},
				fields: [
                    {
                    	available: $rootScope.user.groupType=='SUPPLIER' || $rootScope.user.admin,
                        name: 'groupName',
                        filterType: 'clients',
						filterValue: '',
						style: {
							minWidth: '180px',
							'white-space': 'nowrap'
						}
                    },{
                    	available: true,
                        hasLink: true,
                        name: 'code',
                        label: 'PROJECTCODE',
                        filterType: 'text',
                        filterValue: '',
						orderable: true,
						compareType: 'projectCode',
						style: {
							'white-space': 'nowrap'
						}
                    },{
                    	available: $rootScope.user.groupType=='CLIENT',
                        name: 'clientCode',
                        filterType: 'text',
                        filterValue: '',
                        orderable: true,
						style: {
							minWidth: '200px'
						}
                    },{
                    	available: true,
                        hasLink: true,
                        name: 'name',
                        label: 'PROJECTNAME',
                        filterType: 'text',
                        filterValue: '',
						orderable: true,
						style: {
							minWidth: '400px'
						}
                    },{
                    	available: $rootScope.user.admin,
                        label: 'ASSIGNEE',
                        name: 'assigneeName',
                        filterType: 'admins',
                        filterValue: '',
						style: {
							minWidth: '160px',
							'white-space': 'nowrap'
						}
                    },{
                    	available: $rootScope.user.admin || ($rootScope.user.groupType=='CLIENT' && $rootScope.user.superUser),
                        name: 'ownerName',
                        filterType: 'owners',
                        filterValue: '',
						style: {
							minWidth: '180px',
							'white-space': 'nowrap'
						}
                    },{
                    	available: $rootScope.user.admin || $rootScope.user.groupType=='CLIENT',
                        name: 'recoveredWords',
                        filterType: 'number',
                        filterValue: ''
                    },{
                    	available: true,
                        name: 'status',
                        label: 'PROJECTSTATUS',
                        type: 'enum',
                        enumType: 'status',
                        filterType: 'select',
                        filterOptions: [
                                        {value:'', label:''},
                                        {value:"DRAFT", label:'enums.status.DRAFT'},
                                        {value:"SENT", label:'enums.status.SENT'},
                                        {value:"ANALYSIS", label:'enums.status.ANALYSIS'},
                                        {value:"REVISION", label:'enums.status.REVISION'},
                                        {value:"ESTIMATION", label:'enums.status.ESTIMATION'},
                                        {value:"CONFIRMED", label:'enums.status.CONFIRMED'},
                                        {value:"PROCESSING", label:'enums.status.PROCESSING'},
                                        {value:"DELIVERED", label:'enums.status.DELIVERED'},
                                        {value:"STOPPED", label:'enums.status.STOPPED'},
                                        {value:"ARCHIVED", label:'enums.status.ARCHIVED'}
                                        ],
						style: {
							'min-width': '160px',
							'white-space': 'nowrap'
						}
                    },{
                    	available: true,
                        name: 'delivery',
                        type: 'date',
                        filterType: 'date',
                        filterValue: '',
                        orderable: true,
						style: {
							'min-width': '200px'
						}
                    },{
                    	available: true,
                        name: 'source',
                        type: 'enum',
                        enumType: 'language',
                        filterType: 'language',
                        filterValue: '',
						style: {
							'min-width': '200px'
						}
                    },{
                    	available: true,
                        name: 'destinations',
                        type: 'enumSet',
                        enumType: 'language',
                        filterType: 'multilanguage',
                        filterValue: '',
						style: {
							'min-width': '300px'
						}
                    },{
                    	available: $rootScope.user.groupType!='SUPPLIER',
                        name: 'supplierName',
                        label: 'CHOSENSUPPLIER',
                        filterType: 'suppliers',
                        filterValue: '',
						style: {
							minWidth: '180px',
							'white-space': 'nowrap'
						}
                    },{
                    	available: $rootScope.user.groupType=='SUPPLIER',
                    	name: 'offerSent',
                    	type: 'boolean'
                    },{
                    	available: $rootScope.user.groupType=='SUPPLIER',
                        name: 'confirmed',
                        type: 'enum',
                        enumType: 'confirmedStatus'
                    },{
                    	available: $rootScope.user.groupType!='SUPPLIER',
                    	name: 'actions',
                    	type: 'dropdown',
                    	icon: 'aqi-actions',
                    	actions: [
                                    {
                                        available: $rootScope.user.groupType!='SUPPLIER',
                                        name: 'viewProject',
                                        icon: 'aqi-project',
                                        link: {
                                              action: 'view',
                                              type: 'project',
                                              filter: 'id'
                                          }
                                    },{
			          	        	  available: $rootScope.user.groupType!='SUPPLIER',
			        	        	  name: 'logProject',
			        	        	  icon: 'aqi-log',
			        	        	  link: {
			        	                	action: 'actionlog',
			        	                    type: 'project',
			        	                    filter: 'id'
			        	                }
			        	          },
			        	          {
			          	        	  available: $rootScope.user.groupType!='SUPPLIER',
			        	        	  name: 'viewReport',
			        	        	  icon: 'aqi-report',
			        	        	  link: {
			        	                	action: 'report',
			        	                    type: 'project',
			        	                    filter: 'id'
			        	                },
			        	              condition: function(model){
			        	            	  return model.status=='REVISION' || model.status=='ESTIMATION' || model.status=='CONFIRMED' || model.status=='PROCESSING' || model.status=='DELIVERED' || model.status=='ARCHIVED' || model.status=='STOPPED';
			        	              }
			        	          },
			        	          {
			          	        	  available: $rootScope.user.groupType!='SUPPLIER',
			        	        	  name: 'editProject',
			        	        	  icon: 'aqi-action-edit',
			        	        	  link: {
			        	                	action: 'edit',
			        	                    type: 'project',
			        	                    filter: 'id'
																},
																showDisabled: true,
			        	              condition: function(model){
			        	            	  return model.status=='DRAFT' || model.status=='SENT' || model.status=='REVISION';
			        	              }
			        	          },
                                  {
			          	        	  available: $rootScope.user.groupType=='CLIENT',
			        	        	  name: 'cloneProject',
			        	        	  icon: 'aqi-action-clone',
			        	        	  link: {
			        	                	action: 'clone',
			        	                    type: 'project',
			        	                    filter: 'id'
			        	                }
			        	          },
                    	          {
                    	        	  available: ($rootScope.user.superUser && $rootScope.user.groupType=='CLIENT') || $rootScope.user.groupType=='ADMIN',
                    	        	  name: 'changeOwner',
                    	        	  icon: 'aqi-owner',
                    	        	  link: {
                    	                	action: 'changeowner',
                    	                    type: 'project',
                    	                    filter: 'id'
                    	                }
                    	          },{
									available: $rootScope.user.groupType=='ADMIN',
									name: 'wait',
									icon: 'aqi-action-wait',
									link: {
										  action: 'list',
										  type: 'wait',
										  filter: 'id'
									  },
			        	              condition: function(model){
			        	            	  return model.status=='ANALYSIS';
			        	              }
								},{
                    	        	  available: $rootScope.user.groupType=='ADMIN',
                    	        	  name: 'modifyDate',
                    	        	  icon: 'aqi-calendar',
                    	        	  link: {
                    	                	action: 'modifydate',
                    	                    type: 'project',
                    	                    filter: 'id'
                    	                },
			        	              condition: function(model){
			        	            	  return model.status=='CONFIRMED' || model.status=='PROCESSING';
			        	              }
                    	          },{
                    	        	  available: $rootScope.user.groupType=='ADMIN',
                    	        	  name: 'modifySource',
                    	        	  icon: 'aqi-language',
                    	        	  link: {
                    	                	action: 'modifysource',
                    	                    type: 'project',
                    	                    filter: 'id'
                    	                },
			        	              condition: function(model){
			        	            	  return model.status=='REVISION' || model.status=='ESTIMATION' || model.status=='CONFIRMED' || model.status=='PROCESSING';
			        	              }
                    	          },{
                    	        	  available: $rootScope.user.groupType=='ADMIN',
                    	        	  name: 'editclientcode',
                    	        	  icon: 'aqi-action-edit',
                    	        	  link: {
                    	                	action: 'editclientcode',
                    	                    type: 'project',
                    	                    filter: 'id'
                    	                }
                    	          },{
			          	        	  available: $rootScope.user.groupType!='SUPPLIER',
			        	        	  name: 'viewOffers',
			        	        	  icon: 'aqi-offer',
			        	        	  link: {
			        	                	action: 'offers',
			        	                    type: 'project',
			        	                    filter: 'id'
			        	                },
				        	              condition: function(model){
				        	            	  return model.status=='ESTIMATION' || model.status=='CONFIRMED' || model.status=='PROCESSING' || model.status=='ARCHIVED' || model.status=='STOPPED' || model.status=='DELIVERED';
				        	              }
			        	          },
                    	          {
                    	        	  available: $rootScope.user.groupType=='ADMIN',
                    	        	  name: 'files',
                    	        	  icon: 'aqi-files',
                    	        	  link: {
                    	                	action: 'files',
                    	                    type: 'project',
                    	                    filter: 'id'
                    	                }
                    	          },{
			          	        	  available: $rootScope.user.groupType!='SUPPLIER',
			        	        	  name: 'archiveProject',
			        	        	  icon: 'aqi-status-archived',
			        	        	  link: {
			        	                	action: 'archive',
			        	                    type: 'project',
			        	                    filter: 'id'
			        	                },
			        	              condition: function(model){
			        	            	  return model.status=='DELIVERED';
			        	              }
			        	          },{
			          	        	  available: $rootScope.user.groupType=='CLIENT',
			        	        	  name: 'stopProject',
			        	        	  icon: 'aqi-action-close',
			        	        	  link: {
			        	                	action: 'close',
			        	                    type: 'project',
			        	                    filter: 'id'
																},
																showDisabled: true,
			        	              condition: function(model){
			        	            	  return model.status=='DRAFT' || model.status=='SENT' || model.status=='REVISION' || model.status=='ESTIMATION';
			        	              }
			        	          },{
                    	        	  available: $rootScope.user.groupType=='ADMIN',
                    	        	  name: 'backtoanalysis',
                    	        	  icon: 'aqi-action-go-back',
                    	        	  link: {
                    	                	action: 'backtoanalysis',
                    	                    type: 'project',
                    	                    filter: 'id'
                    	                },
			        	              condition: function(model){
			        	            	  return model.status=='ESTIMATION';
			        	              }
                    	          },{
			          	        	  available: $rootScope.user.groupType=='ADMIN',
			        	        	  name: 'stopProject',
			        	        	  icon: 'aqi-action-close',
			        	        	  link: {
			        	                	action: 'close',
			        	                    type: 'project',
			        	                    filter: 'id'
			        	                }
			        	          },{
                    	        	  available: $rootScope.user.groupType=='ADMIN',
                    	        	  name: 'deleteProject',
                    	        	  icon: 'aqi-action-delete',
                    	        	  link: {
                    	                	action: 'delete',
                    	                    type: 'project',
                    	                    filter: 'id'
                    	                }
                    	          },{
                    	        	  available: $rootScope.user.groupType=='ADMIN',
                    	        	  name: 'deliverProject',
                    	        	  icon: 'aqi-status-delivered',
                    	        	  link: {
                    	                	action: 'deliver',
                    	                    type: 'project',
                    	                    filter: 'id'
                    	                },
			        	              condition: function(model){
			        	            	  return model.status=='ANALYSIS';
			        	              }
                    	          },{
                    	        	  available: $rootScope.user.groupType=='ADMIN',
                    	        	  name: 'changeStatus',
                    	        	  icon: 'aqi-action-changestatus',
                    	        	  link: {
                    	                	action: 'changestatus',
                    	                    type: 'project',
                    	                    filter: 'id'
                    	                }
                    	          }
                    	]
                    },{
						available: $rootScope.user.group.type=='ADMIN' || $rootScope.user.group.type=='CLIENT',
						name: 'selected',
						noLabel: true,
						type: 'checkbox',
						style: {textAlign:'center'},
						icon: 'aqi-actions',
						multiAction: [
							{
								available: $rootScope.user.superUser && $rootScope.user.group.type=='CLIENT',
								name: 'changeOwner',
								icon: 'aqi-owner',
								onclick: function(){
									var models = $filter('filter')($scope.data, $scope.filterData);
									var selected = models.filter(function(m){ return m.selected;});
									$scope.toBeChangedOwnerProjects = models.filter(function(m){ return m.selected && m.owner==$rootScope.user.id;});
									$scope.notToBeChangedOwnerProjects = models.filter(function(m){ return m.selected && m.owner!=$rootScope.user.id;});
									$scope.changedOwnerProjects = [];
									$scope.notChangedOwnerProjects = [];
									if(selected.length>0){
										D.query('account','_disabled=false&group='+$rootScope.user.group.id).then(
											function(response){
												$scope.changeOwnerUserSelect = response;
												var uf = false
												if($rootScope.user.superUser && !$rootScope.user.admin){
													for(var idx=0; idx<$scope.changeOwnerUserSelect.length; idx++){
														if($rootScope.user.id==$scope.changeOwnerUserSelect[idx].id){
															uf = true
														}
													}
													if(!uf){
														$scope.changeOwnerUserSelect = [$rootScope.user].concat($scope.changeOwnerUserSelect)
													}
												}
												$scope.changeOwnerForm = {
													title: '',
													status: '',
													type: 'project',
													model: $scope,
													fields: [
																{
																	available: true,
																	type: 'select',
																	data: $scope.changeOwnerUserSelect,
																	valueField: 'id',
																	labelField: 'name',
																	label: 'labels.SELECTUSER',
																	name: 'changeOwnerSelection',
																	placeholder: 'labels.SELECTUSER',
																	required: true
																}

													]
												}
												ngDialog.openConfirm({
													template: '/app/views/entities/project-confirmchangeowner.html',
													className: 'ngdialog-theme-default',
													scope: $scope
												}).then(function (value) {
													var finished = 0;
													var notifyFn = function(){
														finished++;
														if(finished==selected.length){
															$scope.changingOwners = false
														}
													}
													$scope.changingOwners = true
													ngDialog.open({
														template: '/app/views/entities/project-endchangeowner.html',
														className: 'ngdialog-theme-default',
														scope: $scope
													})
													$scope.changingOwnerProjects = models
													for(var i in models) {
														if(models[i].selected && models[i]._status_selected==='status-pending'){
															//field.onchange(models[i], {action: 'archive'});
															var model = models[i];
															if(model.owner!=value){
																model.action = 'changeOwner';
																model.owner = value;
																model._status_selected = 'status-pending';
																var f = function(model, i){
																	$timeout(function(){
																		D.save('project', model).then(function(response){
																			$scope.changedOwnerProjects.push(model);
																			notifyFn();
																			D.load('project', model.id).then(function(response){
																				model._status_selected = '';
																				model.selected = false
																				model.owner = response.owner;
																				model.ownerName = response.ownerName;
																			}).catch(console.error);
																		}).catch(function(err){
																			$scope.notChangedOwnerProjects.push(model);
																			notifyFn();
																			model._status_selected = 'status-error';
																			D.load('project', model.id).then(function(response){
																				model.selected = false
																				model.owner = response.owner;
																				model.ownerName = response.ownerName;
																			}).catch(console.error);
																		});
																	}, i*1000);
																}
																f(model, i)
																
															} else {
																model.selected = false
																model._status_selected = '';
																$scope.notChangedOwnerProjects.push(model);
																notifyFn();
															}
														}
													}
												});
											}).catch(console.error);
									}
								}
							},
							{
								available: true,
								name: 'archiveProjects',
								icon: 'aqi-status-archived',
								onclick: function(){
									var models = $filter('filter')($scope.data, $scope.filterData);
									var selected = models.filter(function(m){ return m.selected;});
									$scope.toBeArchivedProjects = models.filter(function(m){ return m.selected && m.status=='DELIVERED';});
									$scope.notToBeArchivedProjects = models.filter(function(m){ return m.selected && m.status!='DELIVERED';});
									$scope.archivedProjects = [];
									$scope.notArchivedProjects = [];
									if(selected.length>0){
										ngDialog.openConfirm({
											template: '/app/views/entities/project-confirmmultiarchive.html',
											className: 'ngdialog-theme-default',
											scope: $scope
										}).then(function (value) {
											//var field = $scope.table.fields.filter(function(f){ return f.name==='selected';})[0];
											var finished = 0;
											var notifyFn = function(){
												finished++;
												if(finished==selected.length){
													$timeout(function(){
														ngDialog.open({
															template: '/app/views/entities/project-endmultiarchive.html',
															className: 'ngdialog-theme-default',
															scope: $scope
														})
													}, 500);
												}
											}
											for(var i in models) {
												if(models[i].selected && models[i]._status_selected==='status-pending'){
													//field.onchange(models[i], {action: 'archive'});
													var model = models[i];
													if(model.status=='DELIVERED'){
														model.action = 'archive';
														model._status_selected = 'status-pending';
														var f = function(model){
															D.save('project', model).then(function(response){
																$scope.archivedProjects.push(model);
																notifyFn();
																D.load('project', model.id).then(function(response){
																	model._status_selected = '';
																	model.status = response.status;
																}).catch(console.error);
															}).catch(function(err){
																$scope.notArchivedProjects.push(model);
																notifyFn();
																model._status_selected = 'status-error';
																D.load('project', model.id).then(function(response){
																	model.status = response.status;
																}).catch(console.error);
															});
														}(model);
													} else {
														model._status_selected = '';
														$scope.notArchivedProjects.push(model);
														notifyFn();
													}
												}
											}
										});
									}
								}
						  	}
						],
						onchange: function(model, options){
							model.action = options ? options.action : '';
							model._status_selected = model.selected ? 'status-pending' : '';
							
						}
					}
                ],
                link: {
                	state: 'app.do',
                	action: 'open',
                    type: 'project',
                    filter: 'id'
                },
				links: [{
                	link: $rootScope.user.admin || $rootScope.user.groupType=='SUPPLIER' ? null : {
						action: 'create',
						type:'project',
						filter: ''
					},
                	label: 'labels.ADDNEWPROJECT'
				}],
				loading: true,
				selectAll: function(){
					var models = $scope.data //$filter('filter')($scope.data, $scope.filterData);
					for(var i=0; i<models.length; i++) {
						if(this.selectedAll){
							if(models[i].selected!==false){
								models[i]._status_selected = '';
								models[i].selected = false;
							}
						} else {
							if(models[i].selected!==true){
								models[i]._status_selected = 'status-pending';
								models[i].selected = true;
							}
						}
					}
					if(this.selectedAll){
						this.selectedAll = false;
					} else {
						this.selectedAll = true;
					}
				}
			};
			

            $scope.table.availableFields = $scope.table.fields.filter(function(f){ return f.available; });

			$scope.table.type = 'project';
            
            //$scope.load(50, '', 1);

        } else {
            if(!$scope.watchActivated){
                $scope.watchActivated = true;
                $rootScope.$watch('user.id', function(){
                    if(!$scope.initialized){
                        $scope.init();
                    }
                });
            }
        }
    }

    $scope.init();

    $scope.$on('$destroy', function iVeBeenDismissed() {
      $scope.load = function() { };
    });

}]);
